(() => {
  if (window.customElements.get('size-charts')) return;

  class SizeCharts extends HTMLElement {
    connectedCallback() {
      this.unitButtons = this.querySelectorAll('[data-size-charts-unit]');
      this.inchWraps = this.querySelectorAll('[data-unit-table="inches"]');
      this.cmWraps = this.querySelectorAll('[data-unit-table="cm"]');

      this.unitButtons.forEach((button) => {
        button.addEventListener('click', () => this.setUnit(button.dataset.sizeChartsUnit));
      });
    }

    setUnit(unit) {
      this.unitButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.sizeChartsUnit === unit);
        button.setAttribute('aria-pressed', button.dataset.sizeChartsUnit === unit ? 'true' : 'false');
      });

      this.inchWraps.forEach((wrap) => {
        wrap.hidden = unit !== 'inches';
      });
      this.cmWraps.forEach((wrap) => {
        wrap.hidden = unit !== 'cm';
      });
    }
  }

  customElements.define('size-charts', SizeCharts);
})();
